module.exports = __webpack_public_path__ + "img/compas.e373b21b.svg";